(function () {
    angular
        .module('MktzapApp.Controllers')
        .requires
        .push(
            'ngTable'
        );

    angular.module('MktzapApp.Controllers')
        .controller('CustomerSatisfactionSurveyController', reports);

    reports.$inject = ['LangService', '$http', '$scope', 'ngTableParams', 'CustomerSatisfactionSurveyService', 'NotificationService'];

    function reports(LangService, $http, $scope, ngTableParams, CustomerSatisfactionSurveyService, NotificationService) {

        let vm = this;

        vm.labels = {};

        vm.filters = {
            fromDate: moment().startOf("month").format("DD/MM/YYYY"),
            toDate: moment().endOf("month").format("DD/MM/YYYY"),
            phone: '',
            document: '',
            situation: ''
        };

        LangService
            .getPageLabels({'page':'menu.reports.customer-satisfaction-survey'})
            .$promise
            .then(function(data) {
                vm.labels = data.lang;
            });

        vm.dateSelected = function (type, date) {
            if (type == 'from') {
                vm.pkadayToDate.setMinDate(date);
            }
            if (type == 'to') {
                vm.pkadayFromDate.setMaxDate(date);
            }
        };

        vm.find = () => {
            vm.transactionsTable = new ngTableParams({
                page: 1, // show first page
                count: 30, // count per page
            }, {
                counts: [25, 50, 100],
                getData: function ($defer, params) {
                    var obj = params.url();
                    obj = {
                        page: obj['page'],
                        count: obj['count'],
                        filters: Object.assign({}, vm.filters)
                    }
                    if (obj.filters.phone != "") {
                        obj.filters.phone = "55" + obj.filters.phone;
                    }
                    CustomerSatisfactionSurveyService
                        .paged(obj)
                        .$promise
                        .then(function (retorno) {
                            params.total(retorno.data.total);
                            $defer.resolve(retorno.data.data);
                        }).catch(function ({ data }) {
                            const errors = data.errors.validation
                            if (errors) {
                                errors.map(function (message) {
                                    NotificationService.warningHandler(null, message)
                                })
                            } else {
                                NotificationService.errorHandler(null, data.errors)
                            }
                        })
                }
            })
        }

        vm.download = () => {
            if (vm.filters.phone) {
                vm.filters.phone = "55" + vm.filters.phone;
            }
            $http.get(apiUrl + '/reports/customer-satisfaction-survey-download', {
                params: {
                    filters: vm.filters
                }
            }).then(
                ({ data }) => {
                    console.log(data);
                    if (data.warning) {
                        NotificationService.warningHandler(data, data.message)
                        return
                    }
                    const success = prepareFileForDownload(data)
                    if (!success) {
                        NotificationService.warningHandler(data, $scope.labels.noRecord)
                    }
                },
                (error) => {
                    console.log(error);
                    NotificationService.errorHandler('', $scope.labels.errorReport)
                }
            )
        }

        prepareFileForDownload = data => {
            let component = angular.element('<a/>');
            component.css({ display: 'none' });
            angular.element(document.body).append(component);
            let blob = new Blob([data], { type: 'text/csv' });
            if (blob.size <= 58) {
                return false
            }
            let csvUrl = URL.createObjectURL(blob);
            component.attr({
                href: csvUrl,
                target: '_self',
                download: 'wa_0800_pesquisa.csv'
            })[0].click()
            component.remove()
            URL.revokeObjectURL(csvUrl)
            return true
        }
    }
})();
